import Cookies from "js-cookie";

// Ermittelt das Profilierungscookie
const webCookieName = "GanterWeb2014";

interface WebCookie {
	id?: string;

	values?: {
		ItemIdAnzeigen?: boolean,
		schnellAnmeldenEmail?: string | null,
		schnellAnmeldenId?: string | null,
		Masseinheit?: string,
		CadWeitereFormateToggleStateIsOpen?: boolean,
		CadFormat?: string,
	};
}

function getCookie(): WebCookie {
	try {
		return JSON.parse(Cookies.get(webCookieName)!);
	} catch (e) {
		// Im Fehlerfall einfach von leerem Cookie ausgehen
		return {};
	}
}

export const webCookie = getCookie();

export function saveWebCookie() {
	Cookies.set(webCookieName, JSON.stringify(webCookie), { expires: 365, path: "/" });
}
